import React from "react";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Link from "@material-ui/core/Link";
import MapIcon from "@material-ui/icons/Map";
import { Typography } from "@material-ui/core";
import { positioningElems } from "../../../config/theme";

export const addressRenderer = (
    value,
    name,
    fieldUpdateHandler,
    isError,
    mutable,
) =>
    mutable ? (
        <TextField
            value={value || ""}
            error={!!isError}
            helperText={isError}
            InputProps={
                !value || value?.length === 0
                    ? {}
                    : {
                          endAdornment: (
                              <InputAdornment position="end">
                                  <Link
                                      href={`https://google.com/maps?q=${value}`}
                                      target="_blank"
                                      rel="noopener"
                                  >
                                      <MapIcon />
                                  </Link>
                              </InputAdornment>
                          ),
                      }
            }
            onChange={(e) => fieldUpdateHandler(name, e.target.value)}
        />
    ) : value ? (
        <Typography
            children={[
                <span
                    key={"address_value"}
                    style={positioningElems.inlineWithIcon}
                >
                    {value}
                </span>,
                <Link
                    key={"address_icon"}
                    href={`https://google.com/maps?q=${value}`}
                    target="_blank"
                    rel="noopener"
                >
                    <MapIcon style={positioningElems.distanceToIcon} />
                </Link>,
            ]}
        />
    ) : (
        []
    );
